import { useCompanyInfo } from "@/hooks/useCompanyInfo";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TermsHrContent } from "@/legal/terms/hr";
import { TermsEnContent } from "@/legal/terms/en";
import { LocalePicker } from "@/components/shared/LocalePicker";

const Terms = () => {
  const co = useCompanyInfo();
  const { i18n } = useTranslation();
  const contactEmail = co.email || "info@thenea.app";

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  const locale = (i18n.resolvedLanguage || i18n.language || "hr").toLowerCase();
  const Content = locale.startsWith("en") ? TermsEnContent : TermsHrContent;

  return (
    <div className="min-h-screen bg-background py-20 px-4">
      <div className="container max-w-3xl mx-auto">
        <div className="flex justify-end mb-4">
          <LocalePicker />
        </div>
        <Content company={co} contactEmail={contactEmail} />
      </div>
    </div>
  );
};

export default Terms;
